var _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_phone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stay_current_portrait"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 18 0 18 18 0 18"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray"
    },
    d: "M12.75,0.7575 L5.25,0.75 C4.425,0.75 3.7575,1.425 3.7575,2.25 L3.7575,15.75 C3.7575,16.575 4.425,17.25 5.25,17.25 L12.75,17.25 C13.575,17.25 14.25,16.575 14.25,15.75 L14.25,2.25 C14.25,1.425 13.575,0.7575 12.75,0.7575 L12.75,0.7575 Z M12.75,14.25 L5.25,14.25 L5.25,3.75 L12.75,3.75 L12.75,14.25 L12.75,14.25 Z",
    id: "Shape",
    fill: "#996C49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9aa58b7b0f4ac0348948303a80ee7ed6.svg";
export { ForwardRef as ReactComponent };